<template>
    <div
        class="rounded-lg border-iron-100 bg-white shadow-sm flex h-[56px] w-[56px] shrink-0 items-center justify-center border"
    >
        <img
            height="18"
            width="32"
            src="https://zaptime.s3.eu-central-1.amazonaws.com/application/assets/img/icloud-calendar.png"
        />
    </div>
</template>
